export default __webpack_public_path__ + "static/media/03_DAIF_Eco_05_HUGGING_end.e6d38908.jpg";